import {action, withoutPayload, withPayload} from '../../../utility/redux';

import {
  DocumentPage,
  Media,
  DocumentDownloadUrl,
} from './types';

export const setOpenMediaViewer = action(
  'SET_OPEN_MEDIA_VIEWER',
  withPayload<boolean>(),
);
export const setCurrentIndexMediaViewer = action(
  'SET_CURRENT_INDEX_MEDIA_VIEWER',
  withPayload<number>(),
);
export const setCurrentDocumentPageMediaViewer = action(
  'SET_CURRENT_DOCUMENT_PAGE_MEDIA_VIEWER',
  withPayload<number>(),
);

export const setMediaList = action(
  'SET_MEDIA_LIST_MEDIA_VIEWER',
  withPayload<Media[]>(),
);
export const setLoading = action(
  'SET_LOADING_MEDIA_VIEWER',
  withPayload<boolean>(),
);

export const getDocumentPageListRequest = action(
  'GET_DOCUMENT_PAGE_LIST_MEDIA_VIEWER_REQUEST',
  withPayload<number>(),
);
export const getDocumentPageListSuccess = action(
  'GET_DOCUMENT_PAGE_LIST_MEDIA_VIEWER_SUCCESS',
  withPayload<DocumentPage[]>(),
);
export const getDocumentPageListFail = action(
  'GET_DOCUMENT_PAGE_LIST_MEDIA_VIEWER_FAIL',
  withoutPayload,
);

export const getDocumentDownloadUrlRequest = action(
  'GET_DOCUMENT_DOWNLOAD_URL_MEDIA_VIEWER_REQUEST',
  withPayload<number>(),
);
export const getDocumentDownloadUrlSuccess = action(
  'GET_ARTICLE_DOCUMENT_DOWNLOAD_URL_MEDIA_VIEWER_SUCCESS',
  withPayload<DocumentDownloadUrl>(),
);
export const getDocumentDownloadUrlFail = action(
  'GET_ARTICLE_DOCUMENT_DOWNLOAD_URL_MEDIA_VIEWER_FAIL',
  withoutPayload,
);
export const shouldToggleVideoPlayerInMediaViewer = action(
  'SHOULD_TOGGLE_VIDEO_PLAYER_IN_MEDIA_VIEWER',
  withoutPayload,
);
export const resetToggleVideoPlayerInMediaViewer = action(
  'RESET_TOGGLE_VIDEO_PLAYER_IN_MEDIA_VIEWER',
  withoutPayload,
);
